import ToastConfigure from 'src/shared/components/organisms/toastConfigure';

import { CssBaseline, Box } from '@mui/material';
import { Outlet } from 'react-router-dom';

export const UnprotectedLayout = () => {
  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <Outlet />
      <ToastConfigure />
    </Box>
  );
};
